import BrandTile from "../../molecules/tiles/BrandTile";

const BrandList = ({ brands, getAccessToken }) => (
  <div className="flex flex-col gap-2">
    {brands.map((brand) => (
      <BrandTile
        key={brand.text}
        logoSrc={brand.logoSrc}
        href={brand.href}
        text={brand.text}
        vertical={brand.vertical}
        ssoTarget={brand.ssoTarget}
        returnUrl={brand.returnUrl}
        getAccessToken={getAccessToken}
      />
    ))}
  </div>
);

export default BrandList;
